module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.3211/img/website-performance-rating.jpg"